import { Component, OnInit, ViewChild } from '@angular/core';
import {MenuItem} from 'primeng/api';
import {MenubarModule} from 'primeng/menubar';
import { InternalHomeService } from './internal-home.service';
import { FormCanDeactivate } from '../../../core/guards/deactivate/form-can-deactivate';
import { NgForm } from '@angular/forms';
import * as _ from 'lodash';

@Component({
  selector: 'app-internal-home',
  templateUrl: './internal-home.component.html',
  styleUrls: ['./internal-home.component.scss']
})
export class InternalHomeComponent extends FormCanDeactivate implements OnInit {

  @ViewChild('f', {static: true})
  form!: NgForm;
  items: MenuItem[] = [];
  itemBar: MenubarModule[] = [];

  loading = false;

  constructor(private internalHomeService: InternalHomeService) {
              super();
  }

  ngOnInit() {
    this.internalHomeService.mostrarMenu();
  }

}
